import dayjs from 'dayjs';

import type { AllergyRecord } from '@models/allergy';
import type { ImmunizationRecord } from '@models/immunization';
import type { MedicalConditionRecord } from '@models/medical-condition';
import type { MedicationStatementRecord } from '@models/medication';
import type { ProcedureRecord } from '@models/procedure';

import { isValidDate } from '@utils/date';

export function sortMedications(
  a: MedicationStatementRecord,
  b: MedicationStatementRecord
) {
  const medicationA = a.medication ?? '';
  const medicationB = b.medication ?? '';
  return medicationA.localeCompare(medicationB);
  // if (a.getString('aquisition-type') === b.getString('aquisition-type')) {
  //   const medicationA = a.getString('medication');
  //   const medicationB = b.getString('medication');
  //   return medicationA.localeCompare(medicationB);
  // }
  // return a.getString('aquisition-type') === 'Prescription' ? -1 : 1;
}

export function sortImmunizations(
  a: ImmunizationRecord,
  b: ImmunizationRecord
) {
  const dateA = a.getImmunizationDate() ?? new Date(0);
  const dateB = b.getImmunizationDate() ?? new Date(0);

  return dayjs(dateA).isAfter(dateB) ? -1 : 1;
}

export function sortAllergies(a: AllergyRecord, b: AllergyRecord) {
  const criticalityA = a.criticality;
  const substanceA = a.substance;

  const criticalityB = b.criticality;
  const substanceB = b.substance;

  const severityIndex: Record<string, number> = {
    high: 1,
    low: 0,
    'unable-to-assess': -1,
  };
  const severityKeys = ['severe', 'moderate', 'mild'];

  if (criticalityA === criticalityB) {
    return (substanceA ?? '').localeCompare(substanceB ?? '');
  }

  const keyA = severityKeys.find((key) => criticalityA === key);
  const keyB = severityKeys.find((key) => criticalityB === key);

  if (keyA && keyB) {
    return severityIndex[keyB] - severityIndex[keyA];
  }

  return -1;
}

export function sortSurgeries(a: ProcedureRecord, b: ProcedureRecord) {
  let procedureDateA = a.procedureDate ?? new Date(0);
  let procedureDateB = b.procedureDate ?? new Date(0);

  if (typeof procedureDateA === 'string') {
    const newProcedureDateA = new Date(0, 0, 1, 0, 0, 0, 0);
    newProcedureDateA.setFullYear(parseInt(procedureDateA, 10));
    procedureDateA = newProcedureDateA;
  }
  if (typeof procedureDateB === 'string') {
    const newProcedureDateB = new Date(0, 0, 1, 0, 0, 0, 0);
    newProcedureDateB.setFullYear(parseInt(procedureDateB, 10));
    procedureDateB = newProcedureDateB;
  }

  if (!isValidDate(procedureDateA)) {
    return 1;
  }
  if (!isValidDate(procedureDateB)) {
    return -1;
  }
  return dayjs(procedureDateA).isAfter(procedureDateB) ? -1 : 1;
}

export function sortMedicalConditions(
  a: MedicalConditionRecord,
  b: MedicalConditionRecord
) {
  const dateA = a.onsetDateTime ? dayjs(a.onsetDateTime) : null;
  const dateB = b.onsetDateTime ? dayjs(b.onsetDateTime) : null;

  if (!dateA) {
    return 1;
  }
  if (!dateB) {
    return -1;
  }

  return dateB.isBefore(dateA) ? 1 : -1;
}
